import request from "@/utils/request";

export default function agentGetAllMontylyOrderLogs(params) {
  let url = `/fund/user/allOrderLog/agentGetAllMontylyOrderLogs?orderTypeList=3&orderTypeList=4`;
 
  return request({
    url,
    params,
  });
}
